/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class TopicWelcomeIcon extends BaseIcon {
  getChildren = () => [ <path d="M4,14v3.18L11,20V14L9,16Zm7-2L4,9,2,11.67l6.64,3Zm0-6.12L8.35,4,2,7,3.93,9Z" fill={this.getColor()}/>,<path d="M17.53,6,15,8.53V10H14V8.53L11.47,6H8V5h3.53L14,2.53V0h1V2.53L17.47,5H21V6ZM17,3V2h1V3Zm1-2h1V2H18ZM11,2h1V3H11ZM10,1h1V2H10Zm2,7V9H11V8Zm-1,2H10V9h1Zm7-1H17V8h1Zm1,1H18V9h1Z" fill={this.getColor()}/> ]
  getViewBox = () => '0 0 24 24'
}
